<div class="mediacontainer" #mediacontainer>
    <video controls #video class="video-js vjs-default-skin vjs-big-play-centered" preload="metadata" playsinline [ngStyle]="{display: media.type.startsWith('video') ? 'inherit': 'none'}"></video>
    <audio controls #audio [ngStyle]="{display: media.type.startsWith('audio') ? 'inherit': 'none'}" preload="metadata"></audio>
</div>